import { decoratedSiloKey } from 'queries/decoratedSilo';
import { FC, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { approvalKey } from '../silo/common/ActionForm/Approval';
import { isPausedKey } from '../silo/paused';
import { quotePriceKey } from 'app/queries/price/useQueryQuotePrice';
import { assetPriceKey } from 'app/queries/price/useQueryAssetPrice';
import { userSilosKey } from 'app/queries/positions/fallback';
import { nativeTokenBalanceKey } from '@silo/web3';
import { siloPriceKey } from '../../queries/price/useQuerySiloPrice';
import { totalRewardsBalanceKey } from '../silo/rewards/useQueryTotalRewardsBalance';
import { durationToMilliseconds } from '@silo/utils';

const TWO_MINUTES = durationToMilliseconds({ minutes: 2 });

/**
 * Global app configuration for react query
 */
const useConfigureQueryClient = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      if (!document.hasFocus()) return;

      queryClient.invalidateQueries([nativeTokenBalanceKey]);
      queryClient.invalidateQueries([isPausedKey]);
      queryClient.invalidateQueries([decoratedSiloKey]);
      queryClient.invalidateQueries([quotePriceKey]);
      queryClient.invalidateQueries([approvalKey]);
      queryClient.invalidateQueries([userSilosKey]);
      queryClient.invalidateQueries([assetPriceKey]);
      queryClient.invalidateQueries([siloPriceKey]);
      queryClient.invalidateQueries([totalRewardsBalanceKey]);
    }, TWO_MINUTES);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [queryClient]);
};

export const ConfigureQueryClient: FC = () => {
  useConfigureQueryClient();

  return <></>;
};
